import {
  Avatar,
} from '@mui/material'
import HoverTooltip from '../PageHelpers/HoverTooltip'
import { getFirstAndSecondCharacterOnly } from '../../utils/helpers'

const SideBarAvatar = ({ name, customStyle }) => (
  <HoverTooltip title={name}>
    <Avatar sx={[styles.avatar, customStyle && customStyle]}>
      {getFirstAndSecondCharacterOnly(name || ' ')}
    </Avatar>
  </HoverTooltip>

)

const styles = {
  avatar: {
    width: {
      xs: '28px', sm: '30px', md: '40px', lg: '50px',
    },
    height: {
      xs: '28px', sm: '30px', md: '40px', lg: '50px',
    },
    borderRadius: { xs: '10px', md: '12px' },
    backgroundColor: '#2A374A',
    m: '10px',
    fontWeight: 800,
    fontFamily: 'Avenir',
    fontSize: {
      xs: '15px', sm: '17px', md: '17px', lg: '22px',
    },
    textTransform: 'uppercase',
  },

}

export default SideBarAvatar
